import React from 'react';

import './App.css';

import {AccountProvider} from './contexts/AccountContext';
import {AuthProvider} from './contexts/UserContext';
import {Router} from './routing/router';

const App = () => {
  return (
    <AuthProvider>
      <AccountProvider>
        <div className="appContainer trakGradient">
          <Router />
        </div>
      </AccountProvider>
    </AuthProvider>
  );
};

export default App;
